<template>
  <div class="add-combo">
    <div class="data-form tuolele-main-box">
      <div class="data-form-title">请选择售卖日期</div>
      <div class="form-row">
        <div class="form-input ">
          <span>日期</span>
          <el-date-picker
            v-model="postForm.sell_day"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :disabled="postForm.recipe_id != ''"
          />
        </div>
      </div>
    </div>
    <div class="data-form tuolele-main-box">
      <!-- <div class="data-form-title">菜谱设置</div> -->
      <div class="form-row">
        <div class="form-input fn-clear">
          <Select key="4" :selected.sync="postForm.appoint_period" :data="aSelectAppointList" clearable placeholder="请选择餐次" />
          <el-input
            v-model="postForm.appoint_price"
            type="number"
            size="large"
            placeholder="请输入价格"
          />
          <el-input
            v-model="postForm.recipe_title"
            type="text"
            size="large"
            placeholder="请输入套餐名称"
          />
          <el-button v-if="postForm.status != '1'" type="primary" class="fn-right" @click="fnFindFood('appoint')">添加菜品</el-button>
        </div>
      </div>
      <div class="form-row">
        <div class="form-input ">
          <el-table key="300" :data="aAppointFoodLists" border stripe>
            <el-table-column label="菜品分类" prop="food_type_name" align="center" />
            <el-table-column label="菜品名称" prop="food_name" align="center" />
            <el-table-column label="食材及数量(g)" prop="food_material" align="center" />
            <el-table-column v-if="postForm.status != '1'" label="操作" align="center">
              <template slot-scope="{row}">
                <el-button type="text" style="color:red!important" @click="fnRemove('appoint',row.food_id)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="form-row">
        <div class="form-input fn-clear">
          <el-button v-if="postForm.status != '1'" type="primary" @click="fnSubmit">保存</el-button>

        </div>
      </div>
    </div>
    <el-dialog :key="dialogFindFoodKey" :visible.sync="dialogFindFoodVisible" title="查找菜品" width="700px">
      <div class="data-form ">
        <div class="form-row">
          <div class="form-input">
            <el-input
              v-model="findListQuery.food_name"
              size="large"
              placeholder="请输入名称"
              style="width: 200px;"
            />
            <Select key="5" :selected.sync="findListQuery.food_type" :data="aFoodTypes" clearable placeholder="请选择分类" />
            <el-button type="primary" @click="fnGetFindFoodList()">查找</el-button>
          </div>
        </div>
      </div>
      <div class="data-form ">
        <div class="form-row">
          <div class="form-input">
            <el-table :key="findTableKey" ref="multipleTable" :data="aFindList" border stripe max-height="300" @selection-change="handleSelectionChange">
              <el-table-column
                type="selection"
                width="55"
              />
              <el-table-column label="菜品分类" prop="food_type_name" align="center" />
              <el-table-column label="菜品名称" prop="food_name" align="center" />
            </el-table>
          </div>
          <div class="form-input">
            <el-button type="primary" @click="fnAddFood()">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import Select from '@/components/Select'
import Tool from '@/assets/js/tool.js'

const defaultForm = {
  appoint_period: '', // 定制早中晚餐
  appoint_foods: '', // 定制菜品
  appoint_add_foods: '', // 定制加餐
  appoint_nutrient_content: '', // 定制营养解读
  appoint_price: '', // 价格
  recipe_id: '', // 菜谱ID
  sell_day: '', // 售卖日期
  scope_application: 1// 对内菜谱
}

export default {
  name: 'AddCompanyOrderMenu',
  components: {
    // ShopSelect,
    Select
  },
  data() {
    return {
      postForm: Object.assign({}, defaultForm),
      findListQuery: {
        food_type: '',
        food_name: ''
      },
      findTableKey: 0,
      aFindList: [],
      aSelectAppointList: [],
      aFoodTypes: [],
      aAppointFoodLists: [],
      aFindTempSelectLists: [],
      dialogFindFoodKey: 0,
      dialogFindFoodVisible: false,
      sCurrentAddType: ''

    }
  },
  computed: {},
  watch: {
    aAppointFoodLists: function(val) {
      this.postForm.appoint_foods = (val || []).map((item) => {
        return item.food_id
      }).join(',')
    }
  },
  mounted() {},
  created() {
    if (this.$route.query.id) {
      this.postForm.recipe_id = this.$route.query.id
      this.fnGetRecipe(this.postForm.recipe_id)
    }
    this.fnGetSelectList()
  },
  methods: {
    updateGrade(val) {
      this.selectGrade = val
      this.grade_id = val.join(',')
    },
    fnGetRecipe: function(recipe_id) {
      this.$http.recipeContent({ recipe_id }).then(res => {
        this.postForm = res.data
        this.postForm.recipe_id = recipe_id
        this.postForm.appoint_period = parseInt(this.postForm.appoint_period)
        this.postForm.appoint_price = parseInt(this.postForm.appoint_price) / 100
        this.aAppointFoodLists = res.data.appoint_info || []
      })
    },
    fnGetSelectList: function() {
      this.$http.getDeploy().then(res => {
        this.aSelectAppointList = res.data.recipe_period
        this.aFoodTypes = res.data.food_type
      })
    },
    fnFindFood: function(type) {
      this.sCurrentAddType = type
      this.dialogFindFoodKey++
      this.dialogFindFoodVisible = true
    },
    fnGetFindFoodList: function() {
      this.$http.addRecipeFoodList(this.findListQuery).then(res => {
        this.aFindList = res.data.list
      })
    },
    fnAddFood: function() {
      switch (this.sCurrentAddType) {
        case 'appoint' :
          this.aAppointFoodLists = this.compareArray(this.aAppointFoodLists, this.aFindTempSelectLists)
          break
      }
      this.dialogFindFoodVisible = false
    },
    compareArray: function(list1, list2) {
      var arry = list1.concat([])
      list2.forEach(function name(item) {
        var index = Tool.findIndexInArryByKeyVal(list1, 'food_id', item.food_id)
        if (index < 0) {
          arry.push(item)
        }
      })
      return arry
    },
    fnRemove: function(type, foodId) {
      var self = this
      var index = null

      switch (type) {
        case 'appoint' :
          index = Tool.findIndexInArryByKeyVal(self.aAppointFoodLists, 'food_id', foodId)
          self.removeFoodFromList(self.aAppointFoodLists, index)
          break
      }
    },
    removeFoodFromList: function(list, index) {
      if (index == null) {
        return
      }
      list.splice(index, 1)
    },
    handleSelectionChange: function(val) {
      console.log(val)
      this.aFindTempSelectLists = val
    },
    fnSubmit: function() {
      this.$confirm('食谱日期为: ' + this.postForm.sell_day + '确认是否保存，保存后无法更改日期?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.addRecipe(this.postForm).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.$router.push({
              path: 'foodMenuManage'
            })
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.add-combo {
  .data-form {
    .form-row {
      .form-input {
        .shop-select {
          overflow: hidden;
        }
      }
    }
    .el-select,
    .el-input {
      margin-right: 20px;
    }
    .data-form-title {
      font-size: 20px;
      margin-bottom: 20px;
      color: $color_black;
    }
  }
  .el-button {
    padding: 12px 20px!important;
  }
}
</style>
